import { useEffect, useState } from "react"

export default function useJackpotStates(
  state: string,
  popup: boolean,
  handlepopup: (b: boolean) => void,
) {
  const [removeComponents, setRemoveComponents] = useState(false)
  const [tempRemoveComponents, settempRemoveComponents] = useState(false)

  useEffect(() => {
    let timeoutId: any
    if (state === "initBlackHole") {
      timeoutId = setTimeout(() => {
        setRemoveComponents(true)
        settempRemoveComponents(true)
      }, 5000)
    }
    if (state === "roundStarted" || state === "initRound") {
      settempRemoveComponents(false)
      setRemoveComponents(true)
      handlepopup(true)
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
    }
  }, [state])

  useEffect(() => {
    if (!popup && state === "finished") {
      setRemoveComponents(false)
      settempRemoveComponents(false)
      //aq vanaxot stars
    }
  }, [popup, state])

  return {
    removeComponents,
    tempRemoveComponents,
  }
}
